module.exports = __webpack_public_path__ + "img/receive_success.a0783ee9.png";